export default "/images/vendor/quill/icons/formula.svg?513e689177d9c7b25d1f232b2497570c";